import React from 'react';
import { Link, withRouter } from "react-router-dom";
import '../css/about_section.css'


class AboutSection extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            enableSection1: false,
            enableSection2: false,
            enableSection3: false,
            section1_img: "",
            section1_text: "",
            section1_title: "",
            section1_link: "",
            section2_img: "",
            section2_text: "",
            section2_title: "",
            section2_link: "",
            section3_img: "",
            section3_text: "",
            section3_title: "",
            section3_link: ""
        }
    }

    componentWillMount() {
        if (this.props.context !== undefined && this.props.context !== "") {
            if (this.props.context.home !== undefined && this.props.context.home !== "") {
                if (this.props.context.home.section !== undefined && this.props.context.home.section !== "") {
                    let section1_img = "";
                    let section1_text = "";
                    let section1_title = "";
                    let section1_link = "";
                    let section2_img = "";
                    let section2_text = "";
                    let section2_title = "";
                    let section2_link = "";
                    let section3_img = "";
                    let section3_text = "";
                    let section3_title = "";
                    let section3_link = "";

                    let enableSection1 = false;
                    let enableSection2 = false;
                    let enableSection3 = false;

                    if (this.props.context.home.section.section1 !== undefined) {
                        if (this.props.context.home.section.section1.enableLink !== undefined && this.props.context.home.section.section1.enableLink === "1") {
                            enableSection1 = true;
                        }
                        if (this.props.context.home.section.section1.section_text !== undefined) {
                            section1_text = this.props.context.home.section.section1.section_text;
                        }
                        if (this.props.context.home.section.section1.section_title !== undefined) {
                            section1_title = this.props.context.home.section.section1.section_title;
                        }
                        if (this.props.context.home.section.section1.section_img !== undefined) {
                            section1_img = this.props.context.home.section.section1.section_img;
                        }
                        if (this.props.context.home.section.section1.linkUrl !== undefined) {
                            section1_link = this.props.context.home.section.section1.linkUrl;
                        }
                    }

                    if (this.props.context.home.section.section2 !== undefined) {
                        if (this.props.context.home.section.section2.enableLink !== undefined && this.props.context.home.section.section2.enableLink === "1") {
                            enableSection2 = true;
                        }
                        if (this.props.context.home.section.section2.section_text !== undefined) {
                            section2_text = this.props.context.home.section.section2.section_text;
                        }
                        if (this.props.context.home.section.section2.section_title !== undefined) {
                            section2_title = this.props.context.home.section.section2.section_title;
                        }
                        if (this.props.context.home.section.section2.section_img !== undefined) {
                            section2_img = this.props.context.home.section.section2.section_img;
                        }
                        if (this.props.context.home.section.section2.linkUrl !== undefined) {
                            section2_link = this.props.context.home.section.section2.linkUrl;
                        }
                    }

                    if (this.props.context.home.section.section3 !== undefined) {
                        if (this.props.context.home.section.section3.enableLink !== undefined && this.props.context.home.section.section3.enableLink === "1") {
                            enableSection3 = true;
                        }
                        if (this.props.context.home.section.section3.section_text !== undefined) {
                            section3_text = this.props.context.home.section.section3.section_text;
                        }
                        if (this.props.context.home.section.section3.section_title !== undefined) {
                            section3_title = this.props.context.home.section.section3.section_title;
                        }
                        if (this.props.context.home.section.section3.section_img !== undefined) {
                            section3_img = this.props.context.home.section.section3.section_img;
                        }
                        if (this.props.context.home.section.section3.linkUrl !== undefined) {
                            section3_link = this.props.context.home.section.section3.linkUrl;
                        }
                    }

                    this.setState({
                        enableSection1: enableSection1,
                        enableSection2: enableSection2,
                        enableSection3: enableSection3,
                        section1_img: section1_img,
                        section1_text: section1_text,
                        section1_title: section1_title,
                        section1_link: section1_link,
                        section2_img: section2_img,
                        section2_text: section2_text,
                        section2_title: section2_title,
                        section2_link: section2_link,
                        section3_img: section3_img,
                        section3_text: section3_text,
                        section3_title: section3_title,
                        section3_link: section3_link
                    })
                }
            }
        }
    }


    handleLinkClick(target) {

        switch (target) {
            case "rice":
                if (this.state.section1_link !== "") {
                    window.location.href = this.state.section1_link;
                } else {
                    this.props.history.push('/rice')
                }
                break;

            case "veg":
                if (this.state.section2_link !== "") {
                    window.location.href = this.state.section2_link;
                } else {
                    this.props.history.push('/veg')
                }
                break;

            case "faq":
                if (this.state.section3_link !== "") {
                    window.location.href = this.state.section3_link;
                } else {
                    this.props.history.push('/faq')
                }
                break;
        }
    }


    getSection(target) {
        let section;
        let enableCount = 0;
        let mdClassName = "col-md-12 wow fadeInUp";

        if (this.state.enableSection1) {
            enableCount++;
        }
        if (this.state.enableSection2) {
            enableCount++;
        }
        if (this.state.enableSection3) {
            enableCount++;
        }

        if (enableCount === 2) {
            mdClassName = "col-md-6 wow fadeInUp"
        } else if (enableCount === 3) {
            mdClassName = "col-md-4 wow fadeInUp"
        }


        switch (target) {
            case "1":
                if (this.state.enableSection1) {
                    section = (
                        <div className={mdClassName}>
                            <div className="about-col" onClick={() => this.handleLinkClick('rice')}>
                                <div className="post_overlay"></div>
                                <div className="img">
                                    <img src={this.state.section1_img} alt="" className="img-fluid" />
                                    <div className="icon">{this.state.section1_text}</div>
                                </div>
                                <h2 className="title">{this.state.section1_title}</h2>
                                <div className="title_line"></div>
                            </div>
                        </div>
                    )
                }
                break;

            case "2":
                if (this.state.enableSection2) {
                    section = (
                        <div className={mdClassName} data-wow-delay="0.1s">
                            <div className="about-col" onClick={() => this.handleLinkClick('veg')}>
                                <div className="post_overlay2"></div>
                                <div className="img">
                                    <img src={this.state.section2_img} alt="" className="img-fluid" />
                                    <div className="icon">{this.state.section2_text}</div>
                                </div>
                                <h2 className="title">{this.state.section2_title}</h2>
                                <div className="title_line"></div>
                            </div>
                        </div>
                    )
                }
                break;

            case "3":
                if (this.state.enableSection3) {
                    section = (
                        <div className={mdClassName} data-wow-delay="0.2s">
                            <div className="about-col" onClick={() => this.handleLinkClick('faq')}>
                                <div className="post_overlay3"></div>
                                <div className="img">
                                    <img src={this.state.section3_img} alt="" className="img-fluid" />
                                    <div className="icon">{this.state.section3_text}</div>
                                </div>
                                <h2 className="title">{this.state.section3_title}</h2>
                                <div className="title_line"></div>
                            </div>
                        </div>
                    )
                }
                break;
        }
        return section;
    }

    render() {
        return (
            <div className="aboutsection-frame">
                <section id="about">
                    <div className="container">
                        <header className="section-header"></header>
                        <div className="row about-cols">
                            {this.getSection("1")}
                            {this.getSection("2")}
                            {this.getSection("3")}
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}


export default withRouter(AboutSection)


// WEBPACK FOOTER //
// ./src/component/aboutSection.js